import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=a18e58b4&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=ts"
export * from "./AuthModal.vue?vue&type=script&lang=ts"
import style0 from "./AuthModal.vue?vue&type=style&index=0&id=a18e58b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18e58b4",
  null
  
)

export default component.exports